import { ResultRow } from "@/components/CalcUI";

const th = "px-3 py-2 text-left mono text-[10px] uppercase tracking-wider text-[#94a3b8]";
const td = "px-3 py-2 mono text-xs";

function Table({ testid, headers, rows }) {
  return (
    <div data-testid={testid} className="border border-[#334155] overflow-x-auto">
      <table className="w-full">
        <thead className="bg-[#0b0e13]"><tr>{headers.map((h) => <th key={h} className={th}>{h}</th>)}</tr></thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
}

export function TallyResults({ result }) {
  const s = result.summary;
  const diffColor = s.differential_psi > 0 ? "text-[#fbbf24]" : s.differential_psi < 0 ? "text-[#38bdf8]" : "";
  return (
    <div data-testid="tally-results" className="space-y-6">
      <div className="grid gap-x-8 md:grid-cols-2 border border-[#334155] bg-[#11151c] px-5 py-3">
        <div>
          <ResultRow label="Joints" value={s.joints} />
          <ResultRow label="String length" value={s.string_length_ft?.toLocaleString()} unit="ft" />
          <ResultRow label="Bit / shoe depth" value={s.bit_depth_ft?.toLocaleString()} unit="ft" emphasis />
          <ResultRow label="Pipe capacity volume" value={s.pipe_volume_bbl} unit="bbl" />
          <ResultRow label="Annular volume" value={s.annular_volume_bbl} unit="bbl" />
          <ResultRow label="Total hole volume (w/ string)" value={s.total_hole_volume_bbl} unit="bbl" />
          <ResultRow label="Steel / closed-end displacement" value={`${s.steel_displacement_bbl} / ${s.closed_end_displacement_bbl}`} unit="bbl" />
        </div>
        <div>
          <ResultRow label="Strokes surface → bit" value={s.strokes_surface_to_bit ?? "—"} unit="stk" />
          <ResultRow label="Strokes bottoms-up" value={s.strokes_bottoms_up ?? "—"} unit="stk" />
          <ResultRow label="Hydrostatic at bit (annulus)" value={s.hydrostatic_annulus_psi?.toLocaleString()} unit="psi" emphasis />
          <ResultRow label="Hydrostatic at bit (pipe side)" value={s.hydrostatic_pipe_psi?.toLocaleString()} unit="psi" />
          <ResultRow label="Slug length in pipe" value={s.slug_length_ft} unit="ft" />
          <div data-testid="tally-differential" className={`flex items-baseline justify-between py-2 ${diffColor}`}>
            <span className="text-xs mono uppercase tracking-wider">Differential (pipe − annulus)</span>
            <span className="mono text-lg font-bold">{s.differential_psi?.toLocaleString()} <span className="text-[10px] text-[#64748b]">psi</span></span>
          </div>
          <p className="text-[10px] text-[#64748b]">Positive = pipe side heavier (U-tubes toward the annulus / dry trip). Negative = annulus heavier.</p>
        </div>
      </div>

      <Table
        testid="tally-annular-table"
        headers={["Section", "Hole/Csg ID", "Top–Bottom ft", "String in section ft", "Ann. cap bbl/ft", "Ann. vol bbl"]}
        rows={result.holes.map((h) => (
          <tr key={`${h.name}-${h.bottom}`} className="border-t border-[#334155]/60">
            <td className={td}>{h.name}</td><td className={td}>{h.id}</td><td className={td}>{h.top.toLocaleString()}–{h.bottom.toLocaleString()}</td>
            <td className={td}>{h.length_with_string.toLocaleString()}</td><td className={td}>{h.annular_cap_bbl_ft ?? "—"}</td><td className={`${td} text-[#fbbf24]`}>{h.annular_vol_bbl}</td>
          </tr>
        ))}
      />

      {result.overbalance.length > 0 && (
        <Table
          testid="tally-overbalance-table"
          headers={["Depth ft", "Point", "Mud hydrostatic psi", "Pore psi", "Overbalance psi", "Margin ppg"]}
          rows={result.overbalance.map((o) => (
            <tr key={`${o.depth}-${o.label}`} className="border-t border-[#334155]/60">
              <td className={td}>{o.depth.toLocaleString()}</td><td className={td}>{o.label}</td><td className={td}>{o.hydrostatic_psi.toLocaleString()}</td>
              <td className={td}>{o.pore_psi.toLocaleString()}</td>
              <td className={`${td} font-bold ${o.overbalance_psi < 0 ? "text-[#ef4444]" : "text-[#22c55e]"}`}>{o.overbalance_psi.toLocaleString()}</td>
              <td className={td}>{o.emw_margin_ppg}</td>
            </tr>
          ))}
        />
      )}
    </div>
  );
}
